import React, { Component } from 'react';

import isEqual from 'lodash/isEqual';
import PassChangeForm from './PassChangeForm';
import { RootStore } from '../../stores/RootStore';
import { inject, observer } from 'mobx-react';
import { localizedStrings } from '../../localizedStrings';

interface State {
  passMain: string;
  passRetype: string;
  loading: boolean;
  errors: { main: boolean; retype: boolean };
  disabled: boolean;
}

interface Props {
  rootStore?: RootStore;
}

@inject('rootStore')
@observer
class ChangeStaffPassword extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      passMain: '',
      passRetype: '',
      loading: false,
      errors: { main: false, retype: false },
      disabled: false,
    };
  }
  componentDidMount(): void {
    // eslint-disable-next-line
    this.props
      .rootStore!.getProjectStaffPassword()
      // eslint-disable-next-line
      .then(() => this.setState({ passMain: this.props.rootStore!.staffPassword }));
  }

  componentDidUpdate(prevProps: Props, prevState: State): void {
    // eslint-disable-next-line
    if (!this.props.rootStore!.staffAccount && !this.state.disabled) {
      this.setState({ disabled: true });
    }
  }

  handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ loading: true });
    if (this.checkValidity()) {
      // was valid, class store function, cancel loading, clear input, return
      // eslint-disable-next-line
      this.props.rootStore!.ChangeStaffPassword(this.state.passMain).finally(() => {
        this.setState({ loading: false });
        this.setState((prevState) => ({ ...prevState, errors: { main: false, retype: false } }));
      });
      this.handleCancel();
      return;
    }
    // was not valid, just cancel loading the error message is handled via "is-invalid" class
    this.setState({ loading: false });
  };

  onInputChange = ({ target: { name, value } }: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState((prevState) => ({ ...prevState, [name]: value }));
  };

  checkValidity = (): boolean => {
    const regex = /^([0-9]){6,8}$/;
    if (!regex.test(this.state.passMain)) {
      this.setState((prevState) => ({ ...prevState, errors: { ...prevState.errors, main: true } }));
      return false;
    }
    this.setState((prevState) => ({ ...prevState, errors: { ...prevState.errors, main: false } }));
    return this.checkPassMatch();
  };

  checkPassMatch = (): boolean => {
    if (!isEqual(this.state.passMain, this.state.passRetype)) {
      this.setState((prevState) => ({ ...prevState, errors: { ...prevState.errors, retype: true } }));
      return false;
    }
    this.setState((prevState) => ({ ...prevState, errors: { ...prevState.errors, retype: false } }));
    return true;
  };

  handleCancel = (): void => {
    this.setState({ passMain: '', passRetype: '' });
  };
  render(): React.ReactNode {
    const { passMain, passRetype, loading, errors, disabled } = this.state;
    return (
      <PassChangeForm
        onInputChange={this.onInputChange}
        handleCancel={this.handleCancel}
        handleSubmit={this.handleSubmit}
        passMain={passMain}
        passRetype={passRetype}
        // eslint-disable-next-line
        title={`${localizedStrings.settings.changeStaffPass} (${this.props.rootStore!.staffAccount})`}
        loading={loading}
        uniqueId="id_changestaffpassword"
        errors={errors}
        disabled={disabled}
      />
    );
  }
}

export default ChangeStaffPassword;
